// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1mVID","buttons":"RemoveExpirationActionButtons_buttons__1fmHv"};